import * as React from 'react';
import { useSelector } from 'react-redux';
import { Button } from '@cian/ui-kit';
import { TButtonSize, TButtonTheme } from '@cian/ui-kit/button/types';

import { checkFsk, getUser, getUserPhone } from '../../selectors';
import { TRequestCallbackOpener } from '../../types/microfrontends/newbuildingCallbackWidget';
import { createLabel, phoneToString } from '../../utils';
import { createGaUser } from '../../utils/analytics/createGaUser';
import { NewbuildingCallbackWidgetContext } from '../NewbuildingCallbackWidgetProvider';
import { getBuilder, getDeveloper, getSellers, getTimezone } from '../../selectors/developerV2';

interface ICallbackProps {
  fullWidth?: boolean;
  place: TRequestCallbackOpener;
  size: TButtonSize;
  theme: TButtonTheme;
  buttonText?: string;
}

export function CallbackButtonContainer({
  fullWidth,
  place,
  size,
  theme,
  buttonText = 'Перезвоните мне',
}: ICallbackProps) {
  const [isLoading, setLoading] = React.useState(false);
  const user = useSelector(getUser);

  const builder = useSelector(getBuilder);
  const sellers = useSelector(getSellers);
  const developer = useSelector(getDeveloper);
  const userPhoneNumber = useSelector(getUserPhone);
  const timezoneOffset = useSelector(getTimezone);

  const openWidget = React.useContext(NewbuildingCallbackWidgetContext);

  const preparedPhone = React.useMemo(() => {
    const contact = (builder?.showPhone && builder) || sellers[0];

    return phoneToString(contact?.phone);
  }, [builder, sellers]);

  const preparedRealtyId = React.useMemo(() => {
    const contact = (builder?.showPhone && builder) || sellers[0];

    return contact?.realtyUserId;
  }, [builder, sellers]);

  const isFsk = useSelector(checkFsk);

  const handlePopupOpen = React.useCallback(async () => {
    if (!preparedPhone) {
      return;
    }

    setLoading(true);

    await openWidget({
      agentPhone: preparedPhone,
      timezoneOffset,
      userPhoneNumber,
      builderRealtyUserId: preparedRealtyId as number,
      newbuildingId: null,
      theme: isFsk ? 'fsk' : undefined,
      trackingParams: {
        category: 'CardBuilder',
        opener: place,
        gaLabel: createLabel(developer.id),
        user: createGaUser(user),
      },
    });

    setLoading(false);
  }, [preparedPhone, preparedRealtyId, timezoneOffset, userPhoneNumber, developer, place, user, openWidget]);

  if (!preparedPhone) {
    return null;
  }

  return (
    <Button theme={theme} size={size} fullWidth={fullWidth} onClick={handlePopupOpen} loading={isLoading}>
      {buttonText}
    </Button>
  );
}
